"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const StyledSwitch = (0, styled_components_1.default)(antd_1.Switch) `
	& {
		background-color: ${props => (0, polished_1.transparentize)(0.7, props.theme.color.gray5)};
	}
	&.ant-switch-checked {
		background-color: ${props => props.theme.color.success};
	}
`;
function Switch(props) {
    return (0, jsx_runtime_1.jsx)(StyledSwitch, { ...props, defaultChecked: props.checked });
}
exports.default = Switch;
